import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int) {
    getCollectionOrdersStates(
      where: $where
      offset: $offset
      limit: $limit
      order: "sortOrder ASC"
    ) {
      data {
        id: value
        name
        sortOrder
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

const formatStatusLabel = (state: { name?: string }) => {
  return (
    state.name
      ?.replace('Η Αίτηση', 'Το Αίτημα')
      .replace('η αίτηση', 'το αίτημα')
      .replace('Αίτησης', 'Αιτήματος')
      .replace('αίτησης', 'αιτήματος')
      .replace('Αίτηση', 'Αίτημα')
      .replace('αίτηση', 'αίτημα') ?? ''
  );
};

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
  sbLabel?: string;
  isMulti?: boolean;
}

export const FieldSelectCollectionOrderState2 = ({
  label = 'Κατάσταση Αιτήματος Συλλογής',
  name = 'statusId',
  defaultValues = {},
  sbLabel = '',
  size = 'sm',
  isMulti = true,
  ...rest
}: LcFsProps) => {
  const where = JSON.stringify({ isActive: 1 });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetValues}
      height={size === 'lg' ? 32 : '22'}
      sortOptionValues={false}
      sbLabel={sbLabel}
      recordLabel="name"
      formatLabel={formatStatusLabel}
      isMulti={isMulti}
      // Στο multi dropdown: checked/unchecked tick ανά επιλογή
      showOptionCheckbox={isMulti}
    />
  );
};
